import { Form, Formik } from 'formik';
import { useMemo } from 'react';
import useSWR from 'swr';

import { queryParams } from '@shared/commonFunctions';
import { Modal } from '@shared/components/modals/Modal';
import { SERVICES } from '@shared/constants/apiConfig';

import { OneToOneConsentPresentedAndAccepted } from '@shared/constants/constants';
import { IAsset } from '../../Assets/interfaces';
import { getAssetOptions } from '../../Assets/utils';
import { ILead, ILeadModalProps, InitialStateLeadFormType } from '../types/interfaces/interfaces';
import { leadValidationSchema } from '../validations';
import { LeadForm } from './LeadForm';

export const LeadModal = ({
  modalIsOpen,
  isLoading,
  handleSubmit,
  currentLead,
  handleClose,
  secondarySources,
  defaultPrimarySource,
}: ILeadModalProps) => {
  const params = queryParams();

  const { data: assets = [], isLoading: isLoadingAssets } = useSWR<IAsset[]>(
    params?.id && `/${SERVICES.ASSET}/contacts/${params?.id}/assets`,
    { revalidateOnMount: true }
  );

  const initialLeadesState: InitialStateLeadFormType = {
    id: currentLead?.id || '',
    numericId: currentLead?.numericId || 0,
    assetId: currentLead?.assetId || '',
    assetTag: currentLead?.assetTag || '',
    assignedUser: currentLead?.assignedUser,
    primarySourceId: currentLead?.primarySourceId || defaultPrimarySource.id,
    primarySourceName: currentLead?.primarySourceName || defaultPrimarySource.name,
    secondarySourceId: currentLead?.secondarySourceId || '',
    secondarySourceName: currentLead?.secondarySourceName || '',
    currentWorkFlowStepDate: currentLead?.currentWorkFlowStepDate || '',
    currentWorkFlowStepName: currentLead?.currentWorkFlowStepName || '',
    lastActivity: currentLead?.lastActivity || '',
    lastNoteDateTime: currentLead?.lastNoteDateTime || '',
    lastActivityDate: currentLead?.lastActivityDate || '',
    noOfNotes: currentLead?.noOfNotes || 0,
    oneToOneConsentPresentedAndAccepted:
      currentLead?.oneToOneConsentPresentedAndAccepted || OneToOneConsentPresentedAndAccepted.NotAvailable,
  };

  const assetOptions = useMemo(() => getAssetOptions(assets), [assets]);

  return (
    <Modal
      hideBackdrop={isLoadingAssets}
      open={!!modalIsOpen}
      dialogWidth="40vw"
      title="Add New"
      resetPosition={modalIsOpen}
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialLeadesState as ILead}
        validationSchema={leadValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <LeadForm
              isLoading={isLoading}
              handleClose={handleClose}
              value={props.values}
              assetOptions={assetOptions}
              secondarySources={secondarySources}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
